import { render } from "./pointNumberLine.vue?vue&type=template&id=536019c0&scoped=true"
import script from "./pointNumberLine.vue?vue&type=script&lang=js"
export * from "./pointNumberLine.vue?vue&type=script&lang=js"

import "./pointNumberLine.vue?vue&type=style&index=0&id=536019c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-536019c0"]])

export default __exports__